import React, { useMemo } from "react"
import { useRecoilState } from "recoil"

import { isOpenState } from "./state"

const useOrderNews = () => {
  const [isOpen, setIsOpen] = useRecoilState(isOpenState)

  const open = () => setIsOpen(true)

  const close = () => setIsOpen(false)

  const isVisible = useMemo(() => !!global.orderNews, [])

  return { isOpen, open, close, isVisible }
}

export default useOrderNews
